// extracted by mini-css-extract-plugin
export default {"container":"Common_container__X2GJm","heading":"Common_heading__rnyFl","sub_container":"Common_sub_container__aayCn","grid_with_divider":"Common_grid_with_divider__Ujzvp"};